import { v4 as uuidv4 } from 'uuid';
import { basicConditionBlank as blankCondition } from '../../fieldDialogLogic';

export const ruleOptions = [
    { value: 'custom', label: 'Custom' },
    { value: 'phone', label: 'Phone' },
    { value: 'email', label: 'Email' },
    { value: 'ssn', label: 'SSN' },
];

export const createBlankRule = () => ({
    booleanOperator: 'all',
    advancedMode: false,
    conditions: [blankCondition],
    type: uuidv4(),
    message: '',
});

export const createEmailRule = (fact) => ({
    booleanOperator: 'all',
    advancedMode: false,
    conditions: [
        {
            fact: fact,
            operator: 'matches',
            value: '/([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})/',
        },
    ],
    type: uuidv4(),
    message: '',
});

export const createPhoneRule = (fact) => ({
    booleanOperator: 'all',
    advancedMode: false,
    conditions: [
        {
            fact: fact,
            operator: 'matches',
            value: '/.{9,20}/',
        },
    ],
    type: uuidv4(),
    message: '',
});

export const createSsnRule = (fact) => ({
    booleanOperator: 'all',
    advancedMode: false,
    conditions: [
        {
            fact: fact,
            operator: 'matches',
            value: '/\\d{3}-?\\d{2}-?\\d{4}/',
        },
        {
            fact: fact,
            operator: 'doesNotMatch',
            value: '/(000|666)-..-..../',
        },
        {
            fact: fact,
            operator: 'doesNotMatch',
            value: '/...-00-..../',
        },
        {
            fact: fact,
            operator: 'doesNotMatch',
            value: '/...-..-0000/',
        },
        {
            fact: fact,
            operator: 'doesNotMatch',
            value: '/9..-..-..../',
        },
    ],
    type: uuidv4(),
    message: '',
});
